import { Vue, Component } from 'vue-property-decorator'
import s from '~/utils/s'

@Component
export default class CatalogSectionsHeader extends Vue {

  mounted(){
    s(this.$store).unknownPage.changeShowSticky(true);
  }

  beforeDestroy(){
    s(this.$store).unknownPage.changeShowSticky(false);
  }

  render () {
    return (
      <div class="catalog-sections-header">
        <div class="catalog-sections-header__content">
          <h1 class="catalog-sections-header__content-header">
            {s(this.$store).categoriesPage.list.name}
          </h1>
        </div>
      </div>
    )
  }
}
